export const ANALYTICS_EVENTS = {
    END_CLASS_BUTTON: 'end-class-button',
    TIMER_EXPIRED: 'timer-expired'
} as const

export type ZoomClassEndTrigger =
    | typeof ANALYTICS_EVENTS.END_CLASS_BUTTON
    | typeof ANALYTICS_EVENTS.TIMER_EXPIRED
